import { InjectionToken, Provider } from '@angular/core';

export const SNACKBAR_CONTAINER_PROVIDER = new InjectionToken<string>('SNACKBAR_CONTAINER_PROVIDER');

export function provideSnackbarContainer(container: string = 'body'): Provider[] {
  return [
    {
      provide: SNACKBAR_CONTAINER_PROVIDER,
      useValue: container,
    },
  ];
}
